import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TextMarquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Services from "../components/Services";
import Stats from "../components/Stats";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import Coverage from "../components/Coverage";
import QuoteForm from "../components/QuoteForm";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-obsidian">
      <Navbar />
      <main>
        <Hero />
        <TextMarquee />
        <Services />
        <Manifesto />
        <Stats />
        <Gallery />
        <Testimonials />
        <Coverage />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
